__turbopack_context__.v({
  "imageFooter": "vote-module-scss-module__JSYbGq__imageFooter",
  "privacyPolicy": "vote-module-scss-module__JSYbGq__privacyPolicy",
  "responsiveButton": "vote-module-scss-module__JSYbGq__responsiveButton",
  "votingBox": "vote-module-scss-module__JSYbGq__votingBox",
});
